export default __webpack_public_path__ + "static/media/mobile-plan-hover.bdcdb548.svg";